import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase from "../../lib/firebase";
import ar from "../../locale";
import Loading from "../../lib/Loading";
import { title } from "../../constants";
import PhotoUploader from "../../lib/PhotoUploader";
import MatchScheduler from "../../lib/MatchScheduler";
import MatchesTable from "../../lib/MatchesTable";
import ClubsPlayers from "./Player";
import ClubFormations from "./Formations";

export default class ClubsEdit extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      club: {},
      players: [],
      loading: false,
      token: null,
      deleting: {},
      showfinished: false,
    };
    this.matchedKey = this.props.match.params.key;
    this.clubRef = firebase.database().ref("clubs/" + this.matchedKey);
  }

  componentDidMount() {
    super.componentDidMount();
    document.title = title + " - " + ar.clubs;
    this.clubRef.on("value", (snapshot) => {
      if (!snapshot.exists()) {
        this.props.history.replace("/404");
      } else {
        this.state.club = snapshot.val();
        this.updateState();
        window.Tablesaw.init(this.$("#sawtable"));
      }
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.clubRef.off("value");
  }

  showLoading = (show) => {
    this.state.loading = show;
    this.updateState();
  };

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  saveAvatar = (croppedImage) => {
    this.showLoading(true);
    this.uploadAvatar(croppedImage);
  };

  uploadAvatar = (media) => {
    let { club } = this.state;
    if (media) {
      firebase
        .storage()
        .ref("clubs/" + club.key)
        .put(media)
        .then((snapshot) => snapshot.ref.getDownloadURL())
        .then((downloadURL) => this.clubRef.update({ avatar: downloadURL }))
        .then(() => {
          this.showLoading(false);
          this.showSuccess(ar.upload_successful);
        })
        .catch((error) => {
          this.showLoading(false);
          this.showError(error.message);
        });
    }
  };

  updateClubDetails = () => {
    let name = this.name.value;
    let wins = this.wins.value;
    let lost = this.lost.value;
    let draw = this.draw.value;
    let points = this.points.value;
    if (name) {
      this.showLoading(true);
      this.clubRef
        .update({
          name: name,
          wins: wins,
          lost: lost,
          draw: draw,
          points: points,
        })
        .then(() => {
          this.showLoading(false);
          this.showSuccess(ar.operation_successful);
        })
        .catch((error) => {
          this.showLoading(false);
          this.showError(error.message);
        });
    } else {
      this.showError(ar.enter_valid_details);
    }
  };

  toggleFinished = () => {
    this.state.showfinished = !this.state.showfinished;
    this.updateState();
  };

  render() {
    let { loading, club } = this.state;
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card no-toolbar border-0">
                <div className="card-body">
                  <h2 className="card-title">{ar.clubs}</h2>
                  <h5 className="card-subtitle mb-0">
                    {ar.enter_valid_details}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <div className="form-group">
                    <label
                      htmlFor="inputname"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.name}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.name = e)}
                      defaultValue={club.name}
                      className="form-control"
                      id="inputname"
                      placeholder={ar.enter_name}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="wins"
                      className="control-label col-form-label font-weight-bold"
                    >
                      {ar.wins}
                    </label>
                    <input
                      type="number"
                      ref={(e) => (this.wins = e)}
                      defaultValue={club.wins}
                      className="form-control"
                      id="wins"
                      placeholder={ar.wins}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="lost"
                      className="control-label col-form-label font-weight-bold"
                    >
                      {ar.lost}
                    </label>
                    <input
                      type="number"
                      ref={(e) => (this.lost = e)}
                      defaultValue={club.lost}
                      className="form-control"
                      id="lost"
                      placeholder={ar.lost}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="draw"
                      className="control-label col-form-label font-weight-bold"
                    >
                      {ar.draw}
                    </label>
                    <input
                      type="number"
                      ref={(e) => (this.draw = e)}
                      defaultValue={club.draw}
                      className="form-control"
                      id="draw"
                      placeholder={ar.draw}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="points"
                      className="control-label col-form-label font-weight-bold"
                    >
                      {ar.points}
                    </label>
                    <input
                      type="number"
                      ref={(e) => (this.points = e)}
                      defaultValue={club.points}
                      className="form-control"
                      id="points"
                      placeholder={ar.points}
                    />
                  </div>
                  <div className="button-group mt-3">
                    <button
                      type="button"
                      className="btn waves-effect waves-light btn-rounded btn-info min-w100"
                      onClick={this.updateClubDetails}
                    >
                      {ar.save}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <PhotoUploader
                onSaveAvatar={this.saveAvatar}
                avatar={club.avatar}
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-4 no-toolbar">
              <div className="card border-0 mb-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12 mt-2">
                      <h2 className="card-title">{ar.schedule_a_game}</h2>
                      <h5 className="card-subtitle mb-0">
                        {ar.enter_valid_details}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div>{club && club.key && <MatchScheduler team1={club} />}</div>
            </div>
            <div className="col-lg-8 no-toolbar">
              <div className="card border-0 mb-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12 mt-2">
                      <h2 className="card-title">{ar.incomplete_matches}</h2>
                      <div className="card-subtitle mb-0">
                        <div className="custom-control custom-radio p-0">
                          <input
                            type="checkbox"
                            onChange={this.toggleFinished}
                            className="custom-control-input cursor-pointer"
                            id="customControlValidation2"
                            name="radio-stacked"
                            checked={this.state.showfinished}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customControlValidation2"
                          >
                            <span className="pr-4">
                              {ar.show_completed_matches}
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mb-0">
                <div className="card-body">
                  {club && club.key && this.state.showfinished && (
                    <MatchesTable
                      club={club}
                      showfinished={this.state.showfinished}
                    />
                  )}
                  {club && club.key && !this.state.showfinished && (
                    <MatchesTable club={club} />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                {" "}
                <a
                  className={"nav-link pl-4 pr-4 active"}
                  data-toggle="tab"
                  href="#players"
                  role="tab"
                >
                  <span className="hidden-sm-up"></span>{" "}
                  <span className="hidden-xs-down">{ar.players_list}</span>
                </a>{" "}
              </li>
              <li className="nav-item">
                {" "}
                <a
                  className={"nav-link pl-4 pr-4 "}
                  data-toggle="tab"
                  href="#formations"
                  role="tab"
                >
                  <span className="hidden-sm-up"></span>{" "}
                  <span className="hidden-xs-down">
                    {ar.suggested_formations}
                  </span>
                </a>{" "}
              </li>
            </ul>
            <div className="tab-content tabcontent-border">
              <div
                className="tab-pane p-20 active"
                id="players"
                role="tabpanel"
              >
                {club && club.key && <ClubsPlayers club={club} />}
              </div>
              <div className="tab-pane  p-20" id="formations" role="tabpanel">
                {club && club.key && <ClubFormations club={club} />}
              </div>
            </div>
          </div>
        </div>
        <Loading show={loading} />
      </div>
    );
  }
}
